export default __webpack_public_path__ + "static/media/ethereum-logo.9270fc02.svg";